export const RECORDS_PAINTER_OPACITY = 0.3;
